import { EmptyPlaceholder } from '@euler/app/tv/components/EmptyPlaceholder';
import { TaskListContentLoader } from '@euler/app/tv/components/TaskListContentLoader';
import { usePresentationTheme } from '@euler/app/tv/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';
import { StyleProp, TextStyle, View, ViewStyle } from 'react-native';

export const EmptyTaskListContent = memo(
  ({
    loading,
    error,
    cellMargin,
    cellHeight,
    cellWidth,
    numberOfRows,
    emptyText,
    emptyIconSize,
    emptyTextStyle,
    emptyButtonStyle,
    emptyButtonTextStyle,
    emptyErrorMessage,
    onRefresh,
  }: {
    loading?: boolean;
    error?: Error;
    cellWidth: number;
    cellHeight: number;
    cellMargin: number;
    numberOfRows?: number;
    emptyText?: string;
    emptyIconSize?: number;
    emptyTextStyle?: StyleProp<TextStyle>;
    emptyButtonStyle?: StyleProp<ViewStyle>;
    emptyButtonTextStyle?: StyleProp<TextStyle>;
    emptyErrorMessage?: string;
    onRefresh?: () => void;
  }) => {
    const theme = usePresentationTheme();
    const { rpx } = useResponsiveContext();

    if (loading) {
      return (
        <View
          css={`
            flex: 1;
            justify-content: center;
            padding: ${rpx(44)}px 0;
          `}
        >
          <TaskListContentLoader
            theme={theme}
            cellWidth={cellWidth}
            cellHeight={cellHeight}
            cellMargin={cellMargin}
            numberOfRows={numberOfRows}
            css={`
              flex-grow: 0;
            `}
          />
        </View>
      );
    }

    return (
      <EmptyPlaceholder
        text={
          error
            ? emptyErrorMessage ??
              `对不起，加载服务工单信息失败，服务暂时不可用，请稍候重试！\n如果该错误依然存在，请联系我们，谢谢您的理解和支持！\n(${error.message})`
            : emptyText ?? '暂无相关车辆服务信息'
        }
        error={error}
        onRetry={error ? onRefresh : undefined}
        iconSize={emptyIconSize ?? rpx(250)}
        textStyle={[
          {
            fontSize: rpx(24),
            lineHeight: rpx(44),
            marginTop: rpx(32),
            marginBottom: rpx(32),
          },
          emptyTextStyle,
        ]}
        buttonStyle={emptyButtonStyle}
        buttonTextStyle={emptyButtonTextStyle}
        css={`
          flex: 1;
        `}
      />
    );
  },
);
